import { useEffect } from "react";
import Lenis from "lenis";
import { motionOk } from "../lib/motionOk.js";

export function useLenis() {
  useEffect(() => {
    if (!motionOk) return;
    const lenis = new Lenis({ lerp: 0.08, smoothWheel: true });
    window.__lenis = lenis;
    const raf = (time) => {
      lenis.raf(time);
      requestAnimationFrame(raf);
    };
    requestAnimationFrame(raf);
    return () => {
      lenis.destroy();
      delete window.__lenis;
    };
  }, []);
}
